
import { CollapseTransition } from 'vue2-transitions';
export default {
    name: 'FooterColumn',
    props: ['column', 'activeSectionId'],
    components: {
        CollapseTransition
    },
    methods: {
        isPhoneNumber(str) {
            return /^\+?\d{1,3}?[-.\s]?\(?\d{1,4}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(str);
        },
        isWorkSchedule(str) {
            return /^\d{1,2}:\d{2}-\d{1,2}:\d{2}(,.*)?$/.test(str);
        },
        extractTimeAndDate(str) {
            const [time, date] = str.split(', ');
            return { time, date };
        },
        toggleSection(id) {
            this.$emit('toggleSection', id);
        }
    }
};
